import React, { Component } from 'react';

import OrderTable from './OrderTable';

class OrderSearchResults extends Component {
  componentDidUpdate(){
    console.log("search Component Updated");
    console.log(this.props.orders)
  }
  render(){
    return(
      <div>
        <h1>Search results for <span style={{fontWeight: 700}}>{this.props.query}</span></h1>
        { this.props.orders.length !== 0 &&
          <OrderTable
            refreshPage={this.props.refreshPage}
            headers={['No', 'Date', 'Client', 'Status', 'Active', 'Notes', '']}
            tableData={this.props.orders}
            height={this.props.orders.length * 48}
            editHandler={this.props.goToEditPage}
          />
        }
        { this.props.orders.length === 0 &&
          <div>No orders found!</div>
        }
      </div>
    )
  }
}

export default OrderSearchResults;



// WEBPACK FOOTER //
// ./src/components/Orders/OrderSearchResults.js